import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  notification,
  Row,
  Space,
  Tabs,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { CaretRightOutlined, ControlOutlined } from '@ant-design/icons';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButtonTabsTop';
import { normalize } from 'path';
import ParListSelect from 'components/ParListSelect';
import { Text } from '@react-pdf/renderer';
import { shouldUpdateCompare, toDatePickerDate } from 'utils/utils2';
import AssetCatalogButton from 'pages/Asset/components/AssetGeneralData/AssetCatalogButton';
import ButtonComponent from 'components/Button';

import {
  addParassetfvcontext,
  getParassetfvcontextbyId,
  ParassetfvcontextResponse,
  updateParassetfvcontext,
} from 'services/assetconfig';
import Value from 'components/Value';
import ParAssetFutureValueList from './ParAssetFutureValueList';
import ParAssetFVUseConditionList from './ParAssetFVUseConditionList';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import OfferInput from '../../Management/ParametersFiltering/OfferInput';
import { ArrowLeftOutlined, CloseCircleOutlined } from '@ant-design/icons';

import Button from 'components/ButtonSmall';
import ModalControllerNV from 'components/ModalControllerNV';
import SimulateModal from './SimulateModal';
import Page, { PageModalProps } from 'components/Page';
import { isNil } from 'lodash';
import ModalAssetCatalogItemDetail from 'pages/Configuration/Offers/OfferDetail/ModalAssetCatalogItemDetail';
import ParAssetFVContextDegradationList from './ParAssetFVContextDegradation';
import { AuthContext } from 'components/Auth/Auth';
import PricingInput from 'pages/ProposalV3/PropDetail/PricingInput';
import getEnvValue from 'utils/getEnvValue';
import {
  AssetUseCriteria,
  FilteringCriteria,
  prFilteringCriteria,
} from 'services/pricing';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import IActions from 'icons/IActions';
import ParAssetFutureCriteriaTable from './ParAssetFutureCriteria';
import moment from 'moment';

const { TabPane } = Tabs;
type ParAssetFVContextDetailsprops = PageModalProps & {
  parcontextid?: number;
  catalog?: any;
  refetch?: () => void;
};

const ParAssetFVContextDetails = (props: ParAssetFVContextDetailsprops) => {
  const { isInspect } = useContext(AuthContext);
  const {
    visible = false,
    onCancel,
    showAsModal = false,
    parcontextid: idprops,
    catalog,
    refetch: refetchprop,
  } = props;

  const { Panel } = Collapse;

  const { idOrCreate, duplicate } = useParams<{
    idOrCreate: string;
    duplicate: string;
  }>();

  const isCreate = idOrCreate === 'create' || (showAsModal && isNil(idprops));
  const isDuplicate = duplicate === 'duplicate';
  const [id, setid] = useState<any>(
    !isCreate ? (showAsModal ? idprops : idOrCreate) : undefined
  );
  const [Activekey, setActiveKey] = useState('1');
  const [form] = useForm();
  const [visibleCatalogItemDetails, setVisibleCatalogItemDetails] =
    useState(false);
  const { data: assetuse, refetch } = useQuery(
    ['getParassetfvcontextbyId', { contextid: id }],
    () =>
      getParassetfvcontextbyId({ contextid: Number(id) }).then(
        (res) => res.data
      ),
    {
      enabled: !isNil(id) && !isNaN(Number(id)),
    }
  );

  useEffect(() => {
    if (assetuse) {
      form.setFieldsValue({
        enddate: toDatePickerDate(assetuse?.enddate ?? null),
        startdate: toDatePickerDate(assetuse?.startdate ?? null),
        assetcategory: assetuse?.assetcategory,
        assetfamily: assetuse?.assetfamily,

        assettype: assetuse?.assettype,

        assetsegment: assetuse?.assetsegment,
        assetmodel: assetuse?.assetmodel,
        catalogid: assetuse?.catalogid,
        cataloglabel: assetuse?.cataloglabel,
        contextcode: assetuse?.contextcode,
        contextcodeoriginelabel: assetuse?.contextcodeoriginelabel,

        contextorigin: assetuse?.contextorigin,
        contextstatus: assetuse?.contextstatus,
        contextstatuslabel: assetuse?.contextstatuslabel,
        durationmax: assetuse?.durationmax,
        durationmin: assetuse?.durationmin,
        offerid: assetuse?.offerid,
        ofrid: assetuse?.ofrid,
        ofrtype: assetuse?.ofrtype,
        ofrtypelabel: assetuse?.ofrtypelabel,
        parcontextid: assetuse?.parcontextid,
        parcontextidorigine: assetuse?.parcontextidorigine,
        flagreplace: assetuse?.flagreplace,
        prcode: assetuse?.prcode,

        contextid: isDuplicate ? null : assetuse.parcontextid,
      });
    }
    if (catalog) {
      onAssetSelect(catalog);
    }
  }, [form, isDuplicate, assetuse, id, catalog]);
  const navigate = useNavigate();
  const onSubmit = async (values: ParassetfvcontextResponse) => {
    const requestPaylod = {
      ...values,
      contextstatus: form.getFieldValue('contextstatus'),
    };
    if (isCreate) {
      return values.enddate &&
        values.enddate.length !== 0 &&
        values.startdate > values.enddate
        ? notification.error({
            message: 'the startdate must be less than the enddate',
          })
        : addParassetfvcontext({
            request: { ...requestPaylod },
          }).then((response) => {
            if (response.code === '200') {
              if (showAsModal) {
                refetchprop && refetchprop();
                setid(response.data.parcontextid);
                // onCancel && onCancel();
              } else
                navigate(
                  `/configuration/parassetfvcontextdetail/${response.data.parcontextid}`
                );
              refetch();
              setid(response.data.parcontextid);
              notification.success({ message: response.message });
            } else {
              notification.error({ message: response.message });
            }
          });
    } else {
      return updateParassetfvcontext({
        contextid: Number(id),
        request: { ...requestPaylod },
      }).then((response) => {
        if (response.code === '200') {
          notification.success({
            message: response.message,
          });
          refetchprop && refetchprop();

          refetch();
        } else {
          notification.error({
            message: response.message,
          });
        }
      });
    }
  };
  const onAssetSelect = useCallback(
    (asset) => {
      form.setFieldsValue({
        catalogid: asset.catalogid,
        cataloglabel: asset.assetlabel,
        assetcategorylabel: asset.assetcategorylabel,
        assettype: asset.assettype,
        assetfamily: asset.assetfamily,
        assetmodel: asset.assetmodel,
        assetsegment: asset.assetsegment,
        assetcategory: asset.assetcategory,
        assetmulticomponents: asset.assetmulticomponents,
        assetdescription: asset.assetdescription,
        assetlabel: asset.assetlabel,
        assetnetamount: asset.assetnetamount,
        taxcode: asset.taxcode,
        assettaxamount: asset.assettaxamount,
        assetgrossamount: asset.assetgrossamount,

        assetconstructor: asset.assetconstructor,
        assetComponents: asset.assetCatalogComponents,
        kwhpower: asset.kwhpower,
        kwhproduction: asset.kwhproduction,
        kwhdegradation: asset.kwhdegradation,
        currcode: asset.currcode,
        taxrate: asset.taxrate,
        tpidsupplier: asset.tpidsupplier,
        supplier: {
          tpid: asset.tpidsupplier,
          tpreference: asset.supplierreference,
          tpname: asset.suppliername,
        },
        suppliername: asset.suppliername,
        supplierreference: asset.supplierreference,
        assetunitnetamount: asset.assetnetamount,
      });
    },
    [form]
  );
  const onClearAsset = () => {
    form.setFieldsValue({
      catalogid: null,
      cataloglabel: '',
      assetsegment: '',
      assetmodel: '',
      assetfamily: '',
      assettype: '',
      assetcategory: '',
    });
  };
  const initialValues: ParassetfvcontextResponse = {
    contextcodeoriginelabel: '',
    enddate: '' as any,
    flagreplace: false,
    parcontextidorigine: '' as any,
    startdate: moment() as any,
    assetcategory: '' as any,
    assetfamily: '' as any,
    assettype: '' as any,
    catalogid: '' as any,
    assetmodel: '' as any,
    assetmodellabel: '' as any,
    assetsegment: '' as any,
    assetsegmentlabel: '' as any,
    assetcategorylabel: '' as any,
    assetfamilylabel: '' as any,
    assettypelabel: '' as any,
    cataloglabel: '',
    contextcode: '',
    contextcodelabel: '',
    contextorigin: '',
    contextoriginlabel: '',
    contextstatus: 'INIT',
    contextstatuslabel: 'initial',
    durationmax: 0,
    durationmin: 0,
    offerid: '' as any,
    ofrid: '' as any,
    ofrtype: '',
    ofrtypelabel: '',
    parcontextid: '' as any,
    prcode: '',
  };
  const getFilterList = (): prFilteringCriteria => {
    let assetList = form?.getFieldValue('assets');

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;
    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });
    assetList?.forEach((a: any) => {
      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        offerCriteriaList.push({
          critcode: e.attcode,
          critvalue: e.attstringvalue ?? e.attnumericvalue,
        });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer: assetList ? assetList[0]?.tpidmanufacturer ?? 0 : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria:[],
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };
  return (
    <DF.Provider pagcode="parassetfvcontextdetail">
      <Page
        modalTitle="assetfvcontextdetail"
        showAsModal={showAsModal}
        visible={visible}
        width="95%"
        onCancel={() => {
          onCancel!();
        }}
      >
        <Form
          form={form}
          onFinish={onSubmit}
          initialValues={initialValues}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
        >
          <div className="card-container">
            <Tabs
              defaultActiveKey="1"
              type="card"
              tabBarExtraContent={
                <Space>
                  {assetuse?.parcontextid && (
                    <TasksListPopover
                      entityId={assetuse?.parcontextid}
                      entityName="FVCONTEXT"
                      title={assetuse?.contextcodelabel}
                      onClose={refetch}
                    >
                      <ButtonComponent
                        icon={<IActions height="15px" width="15px" />}
                        comcode="actions"
                        style={{
                          height: 40,
                          marginBottom:6
                        }}
                      />
                    </TasksListPopover>
                  )}
                  <Form.Item
                    shouldUpdate={shouldUpdateCompare('assetnetamount')}
                  >
                    {({ getFieldValue }) => (
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <Button
                            style={{ height: 40 ,marginBottom: -8}}
                            icon={
                              <ControlOutlined
                                style={{ fontSize: 18 }}
                                onClick={() => isInspect && setVisible(true)}
                              />
                            }
                            comcode="simulate"
                            onClick={() => !isInspect && setVisible(true)}
                          />
                        )}
                        modal={({ setVisible, visible }) => (
                          <SimulateModal
                            assetnetamount={getFieldValue('assetnetamount')}
                            visible={visible}
                            parcontexid={Number(id)}
                            onClose={() => setVisible(false)}
                            currcode={getFieldValue('currcode')}
                          />
                        )}
                      />
                    )}
                  </Form.Item>
                  <SaveButton
                    onClick={(ev) => {
                      ev.preventDefault();
                      !isInspect && form.submit();
                    }}
                    comcode="save"
                  />
                </Space>
              }
              activeKey={Activekey}
              onChange={(e) => {
                setActiveKey(e);
              }}
            >
              <TabPane
                tab={
                  <>
                    {' '}
                    <ArrowLeftOutlined
                      onClick={() => {
                        navigate('/configuration/parassetfvcontext');
                      }}
                    />
                    <GetLabel label="AssetFVContextDetail" />
                  </>
                }
                key="1"
              >
                <Collapse
                  bordered={false}
                  defaultActiveKey={['1']}
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined
                      style={{ fontSize: 24 }}
                      rotate={isActive ? 90 : 0}
                    />
                  )}
                  expandIconPosition="left"
                >
                  <Panel
                    header={
                      <Text style={{ fontSize: 22, fontWeight: 'bold' }}>
                        <GetLabel label="generaldata" />
                      </Text>
                    }
                    key="1"
                    style={{
                      marginBottom: 24,
                      overflow: 'hidden',
                      background: '#f7f7f7',
                      border: 10,
                      borderRadius: 2,
                    }}
                  >
                    <Row gutter={30}>
                      {id && (
                        <FormInput
                          col
                          xs={30}
                          lg={5}
                          xl={5}
                          name="contextid"
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                          normalize={normalize}
                        >
                          <Value />
                        </FormInput>
                      )}
                      <FormInput
                        col
                        xs={24}
                        lg={id ? 6 : 5}
                        xl={id ? 6 : 5}
                        name="contextcode"
                      >
                        <ParListSelect parcode="FVCONTEXT" />
                      </FormInput>

                      <FormInput
                        col
                        xs={24}
                        lg={id ? 7 : 6}
                        xl={id ? 7 : 6}
                        name="contextorigin"
                        rules={[{ required: true }]}
                      >
                        <ParListSelect parcode="FVCTXORIG" />
                      </FormInput>
                      {form.getFieldValue('contextstatus') && (
                        <FormInput
                          col
                          xs={24}
                          lg={id ? 6 : 7}
                          xl={id ? 6 : 7}
                          name="contextstatuslabel"
                        >
                          <Value />
                        </FormInput>
                      )}
                    </Row>
                    <Divider />
                    <Row gutter={30}>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare([
                          'catalogid',
                          'assetsegment',
                          'assetfamily',
                          'assettype',
                          'assetcategory',
                        ])}
                        noStyle
                      >
                        {({ getFieldValue, setFieldsValue }) => {
                          const assetsegment = getFieldValue('assetsegment');
                          const assetfamily = getFieldValue('assetfamily');
                          const assettype = getFieldValue('assettype');
                          const assetcategory = getFieldValue('assetcategory');

                          return (
                            <>
                              <FormInput
                                col
                                xs={24}
                                xl={showAsModal ? 10 : 8}
                                name="assetsegment"
                              >
                                <ParListSelect
                                  parcode="ASSETPRD"
                                  disabled={getFieldValue('catalogid')}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      assetsegment: e,
                                      assetfamily: '',
                                      assettype: '',
                                      assetcategory: '',
                                      assetmodel: '',
                                    });
                                  }}
                                />
                              </FormInput>

                              <FormInput
                                col
                                xs={24}
                                xl={showAsModal ? 10 : 8}
                                name="assetfamily"
                              >
                                <ParListSelect
                                  parcode="ASSETFAM"
                                  parvalueparent={assetsegment}
                                  disabled={getFieldValue('catalogid')}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      assetfamily: e,
                                      assettype: '',
                                      assetcategory: '',
                                      assetmodel: '',
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput col xs={8} name="assettype">
                                <ParListSelect
                                  parcode="ASSETTYPE"
                                  parvalueparent={assetfamily}
                                  disabled={getFieldValue('catalogid')}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      assettype: e,
                                      assetcategory: '',
                                      assetmodel: '',
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput col xs={8} name="assetcategory">
                                <ParListSelect
                                  parcode="ASSETCAT"
                                  parvalueparent={assettype}
                                  disabled={getFieldValue('catalogid')}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      assetcategory: e,
                                      assetmodel: '',
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput col xs={8} name="assetmodel">
                                <ParListSelect
                                  parcode="ASSETMODEL"
                                  parvalueparent={assetcategory}
                                  disabled={getFieldValue('catalogid')}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      assetmodel: e,
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput
                                col
                                xs={24}
                                lg={5}
                                xl={5}
                                name="catalogid"
                              >
                                <Form.Item>
                                  <Row>
                                    <Col xs={24} lg={6} xl={6}>
                                      {!catalog && (
                                        <AssetCatalogButton
                                          noName
                                          currcode={localStorage.getItem('currcode') ?? ''}
                                          onSelect={onAssetSelect}
                                        />
                                      )}
                                    </Col>

                                    <Col xs={24} lg={14} xl={14}>
                                      <ModalAssetCatalogItemDetail
                                        cataloglabel={form.getFieldValue(
                                          'cataloglabel'
                                        )}
                                        visible={visibleCatalogItemDetails}
                                        onCancel={() =>
                                          setVisibleCatalogItemDetails(false)
                                        }
                                        currcode={form.getFieldValue(
                                          'currcode'
                                        )}
                                      />
                                    </Col>
                                    <Col xs={24} lg={3} xl={3}>
                                      {form.getFieldValue('catalogid') &&
                                        !catalog && (
                                          <CloseCircleOutlined
                                            style={{
                                              fontSize: '13px',
                                            }}
                                            className="clear-icon"
                                            onClick={onClearAsset}
                                          />
                                        )}
                                    </Col>
                                  </Row>
                                </Form.Item>
                              </FormInput>
                            </>
                          );
                        }}
                      </Form.Item>
                    </Row>
                    <Divider />
                    <Row gutter={30}>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare([
                          'prcode',
                          'offerid',
                          'ofrid',
                          'ofrtype',
                        ])}
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          return (
                            <>
                              <FormInput
                                col
                                xs={24}
                                lg={5}
                                xl={5}
                                name="prcode"
                              >
                                <ProductInput
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      prcode: e,
                                      offerid: '',
                                      ofrid: '',
                                      ofrtype: '',
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput
                                col
                                xs={24}
                                lg={6}
                                xl={6}
                                name="offerid"
                              >
                                <OfferInput
                                  params={{
                                    prcode: getFieldValue('prcode'),
                                    mgid: Number(localStorage.getItem('mgid')),
                                  }}
                                  allData
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      offerid: e,
                                      ofrid: '',
                                      ofrtype: '',
                                    });
                                  }}
                                />
                              </FormInput>

                              <FormInput col xs={24} lg={7} xl={7} name="ofrid">
                                <PricingInput
                                  params={{
                                    catalogid: 0,
                                    duration: 0,
                                    filters: '',
                                    filtersList: getFilterList(),
                                    finamount: 0,
                                    mgid: Number(localStorage.getItem('mgid')),
                                    offerid: form.getFieldValue('offerid'),
                                    prcode: form.getFieldValue('prcode'),
                                  }}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      ofrtype: e.ofrtype,
                                      ofrid:e.ofrid
                                    });
                                  }}
                                />
                              </FormInput>
                              <FormInput
                                col
                                xs={24}
                                lg={5}
                                xl={5}
                                name="ofrtype"
                              >
                                <Input />
                              </FormInput>
                            </>
                          );
                        }}
                      </Form.Item>
                    </Row>
                    <Row gutter={30}>
                      <FormInput col xs={24} lg={5} xl={5} name="durationmin">
                        <InputNumber min={0} />
                      </FormInput>
                      <FormInput col xs={24} lg={6} xl={6} name="durationmax">
                        <InputNumber min={0} />
                      </FormInput>

                      <FormInput col xs={24} lg={7} xl={7} name="startdate">
                        <DatePicker defaultValue={moment()} />
                      </FormInput>
                      <FormInput col xs={24} lg={5} name="enddate">
                        <DatePicker />
                      </FormInput>
                    </Row>
                  </Panel>
                </Collapse>
              </TabPane>

              <TabPane
                tab={<GetLabel label="FutureValueUseCondition" />}
                key="2"
                disabled={isNil(id)}
              >
                <ParAssetFVUseConditionList
                  parcontextid={Number(id)}
                  refetch={refetch}
                  assetfamily={form.getFieldValue('assetfamily')}
                />
              </TabPane>
              <TabPane
                tab={<GetLabel label="Contextdegradation" />}
                key="3"
                disabled={isNil(id)}
              >
                <ParAssetFVContextDegradationList
                  parcontextid={Number(id)}
                  refetch={refetch}
                />
              </TabPane>
              <TabPane
                tab={<GetLabel label="FutureValue" />}
                key="4"
                disabled={isNil(id)}
              >
                <ParAssetFutureValueList
                  parcontextid={Number(id)}
                  refetch={refetch}
                />
              </TabPane>

              <TabPane
                tab={<GetLabel label="AssetFutureCriteria" />}
                key="5"
                disabled={isNil(id)}
              >
                <ParAssetFutureCriteriaTable parcontextid={Number(id)} />
              </TabPane>
            </Tabs>
          </div>
        </Form>
      </Page>
    </DF.Provider>
  );
};

export default ParAssetFVContextDetails;
